import React, { type ReactNode, forwardRef } from 'react';
import classnames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { PACKAGE_CLASSNAME } from '../../../constants';
import { MainRow } from '../MainRow';

interface LayoutProps {
    children: ReactNode;
    isFullWidth?: boolean;
    className?: string;
    /** Allow the header to grow to two rows on mobile (e.g. second-row search). */
    mobileWrap?: boolean;
}

export const Layout = forwardRef<HTMLDivElement, LayoutProps>(
    ({ children, isFullWidth = false, className, mobileWrap = false }, ref) => (
        <Container
            as="header"
            className={classnames(PACKAGE_CLASSNAME, className)}
            paddingTop="4"
            paddingBottom="4"
            height={mobileWrap ? { default: 'auto', md: '86px' } : { default: '65px', md: '86px' }}
            width="100%"
            borderBottomWidth="sm"
            backgroundColor="white"
            ref={ref}
        >
            <MainRow isFullWidth={isFullWidth} mobileWrap={mobileWrap}>
                {children}
            </MainRow>
        </Container>
    )
);

Layout.displayName = 'Layout';
